import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { AuditProposalDetail } from '../types';
import { AuditorCategory, Classification, Standard } from '@/common';

type Body = Partial<{
  note: string;
  workExperience: string;
  education: string;
  training: string;
  workplaceTraining: string;
  standard: Standard | null;
  class: Classification | null;
  auditorCategory: AuditorCategory | null;
  auditorCompetenceIds: string[];
}>;

export const createAuditorProposal = async ({
  data,
}: {
  data: Body;
}): Promise<AuditProposalDetail> => {
  const fetchResponse = await apiFetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-proposal`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditProposalDetail;
  return response;
};
